module.exports = __webpack_public_path__ + "media/promo/advent/images/garland-1-2-4f3af0987d257b7e8936bbe2b7350870.png";